import React, {useEffect, useRef, useState} from "react";
import {state, arState, setGroupVis} from "../../state";
import {Matrix4, Vector3} from "three";
import {useSnapshot} from "valtio";
import {useFrame, useThree} from "@react-three/fiber";
import {ARButton} from "./ARButton";
import IconsRaw from "../ui/icons/IconsRaw";

const ARController = ({group, orbit}) => {
  
  const {currUserDevice} = useSnapshot(state);
  const {getGroupVis} = useSnapshot(arState);
  // local state
  let [active, setActive] = useState(0);
  
  const {gl} = useThree();
  gl.xr.enabled = true;
  
  let arButton = useRef();
  let arControlPanel = useRef();
  
  let hitMatrix = new Matrix4();
  let hitTestSource = null;
  let hitTestSourceRequested = false;
  
  useFrame((state, delta, xrFrame) => {
    
    if (xrFrame) {
      
      let referenceSpace = gl.xr.getReferenceSpace();
      let session = gl.xr.getSession();
      
      if (hitTestSourceRequested === false) {
        session.requestReferenceSpace('viewer').then(function (referenceSpace) {
          session.requestHitTestSource({space: referenceSpace}).then(function (source) {
            hitTestSource = source;
          });
          
        });
        
        session.addEventListener('end', function () {
          
          hitTestSourceRequested = false;
          hitTestSource = null;
          
        });
        
        hitTestSourceRequested = true;
      }
      
      if (hitTestSource) {
        
        const hitTestResults = xrFrame.getHitTestResults(hitTestSource);
        
        if (hitTestResults.length) {
          
          const hit = hitTestResults[0];
          
          hitMatrix.fromArray(hit.getPose(referenceSpace).transform.matrix);
          
          if (!getGroupVis) {
            
            const {position, rotation, scale} = group.current;
            hitMatrix.decompose(position, rotation, scale);
            
          }
        }
      }
    }
  });
  
  // on touch tweak rotation - swipe left / right
  useEffect(() => {
    
    let startX = 0
    let startRotationX = 0;
    
    const handleTouchStart = (event) => {
      startX = event.changedTouches[0].pageX;
      startRotationX = group.current?.rotation.y || 0;
    }
    
    const handleTouchMove = (event) => {
      const touchX = event.changedTouches[0].pageX;
      const diffX = (touchX - startX) / window.innerWidth;
      group.current["rotation"].y = startRotationX + diffX;
    }
    
    window.addEventListener("touchstart", function (e) {
      handleTouchStart(e);
    });
    
    window.addEventListener("touchmove", function (e) {
      if (!active) return;
      handleTouchMove(e);
    });
    
  }, []);
  
  
  useEffect(() => {
    
    const setStopAr = () => {
      
      setGroupVis(true);
      
      btnSet(repositionBtn);
      setActive(active = 0);
      
      orbit.current.target = new Vector3(0, 0, 0);
      
      orbit.current["object"].position.x = 0;
      orbit.current["object"].position.y = 0;
      orbit.current["object"].position.z = 5;
      
      group.current["position"].x = 0;
      group.current["position"].y = 0;
      group.current["position"].z = 0;
      group.current["rotation"].y = 0;
      
    }
    
    const setArInAction = () => {
      
      setGroupVis(false);
      setActive(active = 1);
    }
    
    // fix for apple devices not supporting web.xr - (do reload)
    const chkReload = () => {
      if (currUserDevice === 'IOS_device') {
        location.reload();
      }
    }
    
    const arSection =
      '<div style="display: none" id="arSection" class="ar-section">' +
      '<div class="ar-pos btn">' +
      IconsRaw('icon_position') +
      ' </div>' +
      '<div class="ar-repos btn active">' +
      IconsRaw('icon_reposition') +
      ' </div>' +
      '<div class="ar-close btn">' +
      IconsRaw('icon_close') +
      '</div>' +
      '</div>'
    
    document.body.insertAdjacentHTML('beforeend', arSection);
    
    arControlPanel = document.getElementById('arSection');
    const positionBtn = arControlPanel.getElementsByClassName('ar-pos')[0];
    const repositionBtn = arControlPanel.getElementsByClassName('ar-repos')[0];
    const controlBtns = arControlPanel.getElementsByClassName('btn');
    
    const btnSet = (btn) => {
      [...controlBtns].forEach((btn) => {
        btn.classList.remove('active');
      });
      btn.classList.add('active');
    }
    
    positionBtn.addEventListener('click', function () {
      if (!this.classList.contains('active')) {
        group.current["rotation"].y = gl.xr.getCamera().rotation.y;
        setGroupVis(true);
        btnSet(this);
        setActive(active = 1);
      }
    });
    
    repositionBtn.addEventListener('click', function () {
      setGroupVis(false);
      btnSet(this);
      setActive(active = 0);
    });
    
    // close btn is in ARButton component
    arButton = ARButton.createButton(gl, {
        requiredFeatures: ['hit-test'],
        optionalFeatures: ['dom-overlay'],
        domOverlay: {root: document.body.appendChild(arControlPanel)}
      },
      setArInAction, setStopAr, chkReload);
    
    document.body.appendChild(arButton);
    
  }, []);
  
}

export default ARController;
